import React from 'react'

import { Button, useToggle } from '@factorialco/deprecated-design-system'
import { BudgetEmployeesDatatableQuery } from 'generated/resources/datatable.graphql'

import DataTable, { useDataTable } from 'modules/core/components/DataTable'
import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

import { allocationsWithAmountIds } from 'modules/finance/lib/budget_allocations'

interface ActionsComponentProps {
  handleRemoveEmployee: () => void
  handleAllocationPerEmployee: () => void
  handleRemoveAllocation: () => void
  displayRemoveAllocation: boolean
}

interface DataTableHeaderProps {
  toggleDeleteModal: (value: boolean) => () => void
  toggleAllocationPerEmployeeModal: (value: boolean) => () => void
  toggleRemoveAllocationModal: (value: boolean) => () => void
  search: string
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const ActionsComponent = ({
  handleRemoveEmployee,
  handleAllocationPerEmployee,
  handleRemoveAllocation,
  displayRemoveAllocation,
}: ActionsComponentProps) => {
  const [open, toggle] = useToggle(false)

  return (
    <PopoverMenu type="list" onClick={toggle(!open)} open={open}>
      <PopoverMenu.Trigger>
        <Button.Decorative type="secondary">{i18n.t('common.actions')}</Button.Decorative>
      </PopoverMenu.Trigger>
      <PopoverMenu.Content side="bottom" align="end" aria-label="actions">
        <PopoverMenu.TouchableOption
          title={i18n.t('budgets.detail.tabs.employees.table.actions.allocate_amount')}
          onClick={handleAllocationPerEmployee}
        />
        {displayRemoveAllocation && (
          <PopoverMenu.TouchableOption
            title={i18n.t('budgets.detail.tabs.employees.table.actions.remove_allocation')}
            onClick={handleRemoveAllocation}
          />
        )}

        <PopoverMenu.TouchableOption
          title={i18n.t('budgets.detail.tabs.employees.table.actions.remove')}
          onClick={handleRemoveEmployee}
          danger
        />
      </PopoverMenu.Content>
    </PopoverMenu>
  )
}

const DataTableHeader = ({
  toggleDeleteModal,
  toggleAllocationPerEmployeeModal,
  toggleRemoveAllocationModal,
  search,
  onSearch,
}: DataTableHeaderProps) => {
  const data = useDataTable<BudgetEmployeesDatatableQuery>()
  const allocationIds = Array.from(data.selectedRows)

  const allocationsWithAmountIdsArray = data ? allocationsWithAmountIds(data.data) : []

  const displayRemoveAllocation = allocationIds.some((id) =>
    allocationsWithAmountIdsArray.includes(id)
  )

  return (
    <DataTable.HeadBar
      search={{
        placeholder: i18n.t('common.search'),
        value: search,
        onChange: onSearch,
      }}
      disableExport
      disableEditColumns
      actions={
        allocationIds.length > 0 && (
          <ActionsComponent
            handleRemoveEmployee={() => toggleDeleteModal(true)()}
            handleAllocationPerEmployee={() => toggleAllocationPerEmployeeModal(true)()}
            handleRemoveAllocation={() => toggleRemoveAllocationModal(true)()}
            displayRemoveAllocation={displayRemoveAllocation}
          />
        )
      }
    />
  )
}
export default DataTableHeader
